import React, { useState, useEffect } from "react";
import { emailTemplateService } from "../../utils/services/email-templateService";
import DashboardContainer from "../../components/dashboard-container";
import EmailTemplateModal from "../../components/email-template-modal";
import EmailTemplateList from "../../components/email-template-list";

const EmailTemplateScreen = () => {
  const [templates, setTemplates] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [viewMode, setViewMode] = useState("list");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [total, setTotal] = useState(rowsPerPage);

  const fetchTemplates = () => {
    emailTemplateService
      .fetch(rowsPerPage, page * rowsPerPage)
      .then((response) => {
        setTemplates(response.data);
        setTotal(response.total);
      })
      .catch((e) => {
        console.error(e);
      });
  };
  useEffect(() => {
    // Fetch templates from the API
    fetchTemplates();
  }, [page, rowsPerPage]);

  return (
    <DashboardContainer
      hideFilterClient
      onSearchData={(x) => {
        console.log(x);
      }}
      onClickAddButton={() => {
        setOpenModal(true);
      }}
      hideUploadButton={true}
      header={"Template List"}
      title={"+ Template"}
      setViewMode={setViewMode}
      onClickRefresh={() => fetchTemplates()}
    >
      <EmailTemplateModal
        selectedTemplate={selectedTemplate}
        handleClose={() => {
          setOpenModal(false);
          setSelectedTemplate(null);
        }}
        open={openModal}
        onAddData={fetchTemplates}
      />
      <EmailTemplateList
        dataCount={total}
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        onDeleteData={fetchTemplates}
        onEditData={(e) => {
          setSelectedTemplate(e);
          setOpenModal(true);
        }}
        data={templates}
        viewMode={viewMode}
        selectedTemplate={selectedTemplate}
        setSelectedTemplate={setSelectedTemplate}
      />
    </DashboardContainer>
  );
};

export default EmailTemplateScreen;
